import { isEmail } from 'validator'

// TODO move to @gymaholic/packages
export default function isEmailStringUtil (string = '') {
  return isEmail(string)
}
